import { useMutation } from 'react-query';

import { BookAppointmentResponse } from '@/features/availability/types';
import { axios } from '@/lib/axios';
import { MutationConfig } from '@/lib/react-query';
import { showNotification } from '@/utils/notificationUtils';

export type requestDTO = {
  data: {
    paymentMethodId: string,
    verificationToken?: string,
    paymentProvider?: 'square' | 'stripe',
    paymentMode? : string,
    businessLocationId? :any,
  },
  
};

export const addCreditCard = ({ data }: requestDTO): Promise<BookAppointmentResponse> => {
  const url = data.paymentProvider === 'square' ? 'parent/payment/square/save' : 'parent/payment/save';
  if(data.businessLocationId){
    return axios.post(url, data, {
      headers: {
        'loc-id': data.businessLocationId,
       
      },
    });
  }else{
    return axios.post(url, data);
  }
  
};

type UseUpdateBusinessOptions = {
  config?: MutationConfig<typeof addCreditCard>;
};

export const useAddCreditCard = ({ config }: UseUpdateBusinessOptions = {}) => {
  return useMutation({
    onSuccess: () => {
      showNotification({
        type: 'success',
        title: 'Card added successfully',
      });
    },
    ...config,
    mutationFn: addCreditCard,
  });
};
